export default function PHP_restore_error_handler() {
  return (
    <div>
      <h1>PHP_restore_error_handler</h1>
    </div>
  );
}
